
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface RoadmapCardProps {
  status: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

export const RoadmapCard = ({ status, title, description, icon }: RoadmapCardProps) => {
  return (
    <Card className="feature-card h-full flex flex-col rounded-xl overflow-hidden">
      <CardContent className="p-0 flex-1 flex flex-col">
        <div className="bg-gradient-purple p-4 text-white flex items-center justify-between">
          <h3 className="font-bold">{status}</h3>
          <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-white">
            {icon}
          </div>
        </div>
        <div className="p-6">
          <h3 className="text-xl font-bold mb-3">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
        <div className="shimmer"></div>
      </CardContent>
    </Card>
  );
};
